import React from 'react'
import styled from '@emotion/styled'

import { SearchSummaryContent } from './internals/InnerContent'
import { SearchWithExtras } from 'generated/api'
import { Card } from './internals/styles'
import { CallToActionButton } from './internals/CtaButtons'
import { SearchNotice } from './internals/Notices'

interface Props {
	search?: SearchWithExtras
}

export const DashboardSummaryCard = ({ search }: Props): JSX.Element => {
	return (
		<DashboardCard
			selected={false}
			executed={search?.executed}
			clickable={false}
			onClick={(): void => {
				// do nothing
			}}
		>
			<SearchSummaryContent search={search} constrainTrivia={true}>
				<SearchNotice search={search} />
				<CallToActionButton search={search} />
			</SearchSummaryContent>
		</DashboardCard>
	)
}

const DashboardCard = styled(Card)`
	margin-bottom: 0;
	cursor: default;
	width: 100%;
	padding: 24px;
`
